
import * as React from "react";
import { getGlobalVar } from "../../utils/helpers";

/*
    get avatar component
    Args:
    - data
*/
export const getAvatar = (data) => {
    if (isNaN(parseInt(data.avatar, 10))) {
        return <img src={data.avatar}/>;
    }

    const avatar = getGlobalVar("ITEMS").find(config => config.id === +data.avatar);
    if (!avatar) {
        return <img src={require(`../../../assets/images/misc/DefaultIcon.jpg`).default}/>;
    }

    try {
        avatar.image = require(`../../../assets/images/misc/DefaultIcon.jpg`).default;
    } catch (error) {
        avatar.image = require(`../../../assets/images/misc/DefaultIcon.jpg`).default;
    }

    if (avatar && avatar.id >= 21125) {
        return <div
            className="animated-avatar"
            style={{
                background: `url("${avatar.image}")`,
            }}
        />;
    }

    return <img
        src={avatar.image}
        onError={(e: any) => {
            e.target.onerror = null;
            e.target.src = require(`../../../assets/images/misc/DefaultIcon.jpg`).default
        }}
    />;
}

/*
avatar frame component for tsx
    Args:
    - data
*/
const getAvatarFrame = (data) => {
    try {
        const image = require(`../../../assets/images/misc/not_found.png`).default;

        return <img
            src={image}
        />
    } catch (error) {
        return null;
    }
}

export const Avatar = (data, size = "normal", status = true) => {
    {/*temporarily disabled frame*/}

    // const frame = getAvatarFrame(data);
    const frame = null;
    return <div className={`avatar_wrapper_inner ${size}`} {...data.style && { style: data.style }}>
        {frame && <div className="avatar_frame_wrapper">{frame}</div>}
        <div className={`avatar_wrapper ${!frame ? "without_frame" : ""}`}>{getAvatar(data)}</div>
        {status && <div className={`status-circle ${data.is_online ? "online" : "offline"}`}></div>}
    </div>
}
